import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const EditProgramV2 = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate("/programs-v2");
      return;
    }
    
    // Redirect to step 1 of the edit flow
    navigate(`/programs-v2/${id}/edit/step1`);
  }, [id, navigate]);

  return null; // This component just redirects
};

export default EditProgramV2;